import ErrorOccurred from './ErrorOccurred'

export default ErrorOccurred
